import { GetDateFromString } from "../../../../../../shared/scripts/date-functions";
import { AssessmentLookup } from "./assessments.lookup";

export class Assessment {
    Id: number;
    Name: string;
    OrderBy: number;

    constructor(id: number, name: string, ordering: number) { this.Id = id; this.Name = name; this.OrderBy = ordering; }
}


export class AssessmentEvent {

    private static THIRTY_DAYS_MS: number = 2592000000;

    //Assessments
    AppendixId: number;
    AssessmentId: number;
    CompletionStatusId: number; 
    IsExpected: boolean;
    NameId: number;
    SiteNumber: number;
    StatusId: number;
    StudyId: number;
    SubjectId: string;
    TimepointId: number;
    percentCompleteId: number;
    TargetDate: string;
    TargetDateParsed: Date;


    private _percentComplete: number;

    get PercentComplete(): number {
        return this._percentComplete;
    }

    set PercentComplete(value: number) {
        if (value === 1) {
            this._percentComplete = 100;
        } else {
            this._percentComplete = Math.round(value * 100);
        }
    }

    initialize(): void {
        if (this.StatusId === 1) {
            let percentComplete = this.PercentComplete;

            if (percentComplete === 100) { this.percentCompleteId = 20; }
            else if (percentComplete >= 80) { this.percentCompleteId = 21; }
            else if (percentComplete >= 60) { this.percentCompleteId = 22; }
            else if (percentComplete >= 40) { this.percentCompleteId = 23; }
            else { this.percentCompleteId = 24; }
            //else if (percentComplete > 0 && percentComplete < 39) { this.percentCompleteId = 24; }  

            if (this._percentComplete === undefined) {
                this.PercentComplete = 0;
            }

            if (this.TargetDate) {
                const parsed = new Date(this.TargetDate);
                this.TargetDateParsed = isNaN(parsed.getTime()) ? null : parsed;
            } else {
                this.TargetDateParsed = null;
            }
        }       
    }

}
